import { render, staticRenderFns } from "./AssuranceSupport.vue?vue&type=template&id=6a0a74aa&scoped=true&"
import script from "./AssuranceSupport.vue?vue&type=script&lang=js&"
export * from "./AssuranceSupport.vue?vue&type=script&lang=js&"
import style0 from "./AssuranceSupport.vue?vue&type=style&index=0&id=6a0a74aa&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a0a74aa",
  null
  
)

export default component.exports